import { useI18n } from "@/hooks/useI18n";
import { dictionary } from "@/lib/i18n";
import { PackageCheck, BadgeCheck, FileSignature } from "lucide-react";

const ICONS = { PackageCheck, BadgeCheck, FileSignature };

export const ImportCustoms = () => {
  const { lang } = useI18n();
  const data = dictionary.importSection;

  return (
    <section
      id="import"
      data-testid="import-section"
      className="relative py-24 md:py-28 bg-[#0F2756] text-white overflow-hidden border-b border-[#0A1933]"
    >
      <div className="absolute inset-0 pointer-events-none opacity-20">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.08) 1px, transparent 1px)",
            backgroundSize: "5rem 5rem",
          }}
        />
      </div>
      <div className="absolute -top-32 -right-32 w-[460px] h-[460px] bg-[#1857D6]/40 blur-[160px] pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-[460px] h-[460px] bg-[#4FC3F7]/15 blur-[160px] pointer-events-none" />

      <div className="relative container mx-auto px-6 md:px-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-end mb-12">
          <div className="lg:col-span-8">
            <span
              data-testid="import-label"
              className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#4FC3F7]"
            >
              ▍ {data.label[lang]}
            </span>
            <h2
              data-testid="import-title"
              className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-[1.1]"
              style={{ fontFamily: "Manrope, IBM Plex Sans, sans-serif" }}
            >
              {data.title[lang]}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-base lg:text-lg text-white/75 leading-relaxed">
              {data.intro[lang]}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {data.items.map((item, idx) => {
            const Icon = ICONS[item.icon] || PackageCheck;
            return (
              <article
                key={idx}
                data-testid={`import-card-${idx}`}
                className="group relative bg-[#0F2756] hover:bg-[#13306B] transition-colors duration-300 p-7 lg:p-9 flex flex-col"
              >
                <div className="flex items-start justify-between mb-7">
                  <div className="h-12 w-12 flex items-center justify-center bg-white/10 border border-white/20 group-hover:bg-[#1857D6] group-hover:border-[#1857D6] transition-colors">
                    <Icon className="h-5 w-5 text-[#4FC3F7] group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-[10px] tracking-[0.3em] text-white/40 font-bold">
                    0{idx + 1}
                  </span>
                </div>
                <h3
                  className="text-lg lg:text-xl font-bold text-white leading-snug"
                  style={{ fontFamily: "Manrope, IBM Plex Sans, sans-serif" }}
                >
                  {item.title[lang]}
                </h3>
                <p className="mt-4 text-[14px] text-white/75 leading-relaxed">
                  {item.desc[lang]}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImportCustoms;
